import { render } from "./MatricularCursoDialog.vue?vue&type=template&id=6498d995"
import script from "./MatricularCursoDialog.vue?vue&type=script&lang=js"
export * from "./MatricularCursoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__